/*!
 * UTF-8 Validation Fallback Code originally from:
 * ws: a node.js websocket client
 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
 * MIT Licensed
 */

module.exports.Validation = {
  isValidUTF8: function() {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/web3/~/websocket/lib/Validation.fallback.js
// module id = 1998
// module chunks = 0 1 3